// TODO:
// 만료되는 expire 시간을 설정해서
// 보호한다

// 메모리를 사용하든
// 로컬스토리지를 사용하로
// 세션스토리지를 사용할때는, model을 암호화할것.

// 이름변경하자
// AssetStorage -> InMemoryStorage

// TODO: 여기에 넣어두니까 리로드할때마다 안나옴

let isLogin = false;
let map = new Map(); // 메모리 사용
export default class InMemoryStorage {
  static setLogin(bool) {
    isLogin = bool;
  }

  static isLogin() {
    return isLogin;
  }

  static set(key, str) {
    map.set(key, str);
  }

  static get(key) {
    try {
      const something = map.get(key);

      if (typeof something === "object") return something;
      else if (typeof something === "string") {
        try {
          return JSON.parse(something);
        } catch (error) {
          return something;
        }
      } else return something;
    } catch {
      console.error("AssetStorage.get() error - JSON parsing error");
    }
  }

  static clear() {
    isLogin = false;
    map = new Map();
  }
}
